import { DEFAULT_BORDER } from 'constants/global';
import { defaultReviewsPropsData } from './defaultData';

import MTS from 'assets/icons/companiesLogos/colored/mts.svg';
import NDA from 'assets/icons/companiesLogos/nda.svg';

const cardsData = [
  {
    companyIcon: MTS,
    text: 'Компания Броневик (МТС Трэвел) благодарит ASTON за качественную реализацию IT-проекта. Мы приобрели надёжного партнёра, который ответственно подходит к поставленным задачам. Мы готовы рекомендовать ASTON как надёжного партнёра',
    name: 'Р.А. Десятов',
    position: 'СТО, Компания Броневик (МТС Трэвел)',
  },
  {
    companyIcon: NDA,
    text: 'Мы благодарны команде ASTON за безупречную работу над нашим IT-проектом. В процессе сотрудничества мы нашли ответственного и технологически сильного партнёра, на которого можно положиться. Смело рекомендуем ASTON',
    position: 'Ведущий специалист',
  },
];

const slidesStyles = [
  { bgColor: 'bg.neonLight', iconProps: { bgSize: '60%' } },
  {
    border: DEFAULT_BORDER,
    borderColor: 'line.gray',
    iconProps: { bgSize: '55%', bgColor: 'bg.gray' },
  },
];

export const telecomReviewsPropsData = {
  cardsData: [...cardsData, ...defaultReviewsPropsData.cardsData],
  slidesStyles: [...slidesStyles, ...defaultReviewsPropsData.slidesStyles],
};
